import { apiClient } from "@/api/api-client";
import * as echarts from "echarts";
import ReactECharts from "echarts-for-react";
import moment from "moment-timezone";
import { useEffect, useMemo, useState } from "react";

const LoginHeatmap = () => {
	const [heatmapData, setHeatmapData] = useState<any[]>([]);
	const [maxValue, setMaxValue] = useState<number>(0);

	const fetchLoginData = async () => {
		try {
			const res = await apiClient.get("/backoffice/login-frequency");
			if (res?.data) {
				setHeatmapData(res.data.data);
				setMaxValue(res.data.meta?.max || 0);
			}
		} catch (error) {
			console.error("Failed to fetch login data:", error);
		}
	};

	useEffect(() => {
		fetchLoginData();
	}, []);

	const chartOptions = useMemo(
		() => ({
			tooltip: {
				position: "top",
				formatter: (params: any) => `${params.value[0]} <br/><strong>Total: ${params.value[1]}</strong>`,
			},
			visualMap: {
				min: 0,
				max: maxValue,
				type: "piecewise",
				orient: "horizontal",
				left: "center",
				top: 2,
				show: false,
				inRange: {
					color: ["#eee1f1", "#c7a0d2"],
				},
			},
			calendar: {
				orient: "vertical",
				yearLabel: { show: false },
				dayLabel: {
					firstDay: 7,
					nameMap: ["S", "M", "T", "W", "T", "F", "S"],
					color: "#94a3b8",
					fontSize: 10,
					fontWeight: 700,
				},
				monthLabel: { show: false },
				cellSize: ["auto", 20],
				top: 30,
				left: 10,
				right: 10,
				range: moment().format("YYYY-MM"),
				itemStyle: {
					borderWidth: 3,
					borderColor: "#fff",
				},
				width: 260,
				splitLine: { show: false },
			},
			series: {
				type: "heatmap",
				coordinateSystem: "calendar",
				data: heatmapData,
				label: {
					show: true,
					formatter: (params: any) => {
						const date = echarts.number.parseDate(params.value[0]);
						return date.getDate();
					},
					color: "#643d6b",
					fontSize: 8,
					fontWeight: 700,
				},
			},
		}),
		[heatmapData, maxValue],
	);

	return (
		<div className="w-full">
			<ReactECharts option={chartOptions} style={{ height: "140px", width: "100%" }} />
		</div>
	);
};

export default LoginHeatmap;
